/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TaxInputs */

const en__field_tax = /** @type {(inputs: _Field_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax`)
};

const de__field_tax = /** @type {(inputs: _Field_TaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuer`)
};

/**
* | output |
* | --- |
* | "Tax" |
*
* @param {_Field_TaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_tax = /** @type {((inputs?: _Field_TaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_tax(inputs)
	return de__field_tax(inputs)
});